export const fiveStepsMirea = [
  {
    id: 1,
    title: 'Презентация проекта',
    date: 'сентябрь',
    text: 'Встреча с руководителем офлайн и онлайн'
  },
  {
    id: 2,
    title: 'Отбор кандидатов',
    date: 'октябрь',
    text: 'Подача заявки с мотивационным письмом. Прохождение собеседования.\nCтажировка – 1 месяц'
  },
  {
    id: 3,
    title: `Обучение на программе`,
    date: '1-й семестр',
    text: 'Адаптивная программа включает в себя 16 лекций по профильной дисциплине и практику в лаборатории'
  },
  {
    id: 4,
    title: 'Дипломный проект',
    date: '2 года',
    text: 'Выполнение диссертации по проектам компании на базе лаборатории Mabstudy и R&D\u2011центра Generium'
  },
  {
    id: 5,
    title: 'Трудоустройство в Generium',
    date: 'после защиты диплома',
    text: 'После успешного окончания обучения и защиты диплома выпускники могут продолжить профессиональное развитие в компании'
  }
]
